import { render, staticRenderFns } from "./Accordeon.vue?vue&type=template&id=f5783c50&scoped=true&"
import script from "./Accordeon.vue?vue&type=script&lang=js&"
export * from "./Accordeon.vue?vue&type=script&lang=js&"
import style0 from "./Accordeon.vue?vue&type=style&index=0&id=f5783c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5783c50",
  null
  
)

export default component.exports